module.exports = __webpack_public_path__ + "img/2_bis_10.5c6d3dc4.png";